import React from 'react';

const Component = props => {
	return (
		<>
			<div className='pt-[5px]'>
				<h2 className='text-[36px] text-[#282e3f] mb-[25px]'>Droit des contrats</h2>
			</div>
			<div className='mt-[30px]'>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet d'avocats GAVA-<i>Lex</i> vous conseillera et vous défendra dans tous les dossiers en
					matière de contrats, particulièrement de bail à loyer ou commercial, de construction et de vente.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					En <strong>droit du bail</strong>, il traite, tant pour le bailleur que pour le locataire, les
					contentieux liés aux <strong>baux à loyer</strong> (bail de résidence principale ou secondaire, de
					garage, etc.) et aux <strong>baux commerciaux</strong>.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet vous assistera également dans le cadre de l'exécution des contrats en{' '}
					<strong>matière de construction</strong>, particulièrement ceux passés avec des entrepreneurs. Ces
					dossiers sont souvent délicats et peuvent mettre en cause de nombreux intervenants (sous-traitants,
					architectes, bureaux d'études,…), le cas échéant avec obligation de faire intervenir un expert. Le
					cabinet vous accompagnera tout au long de la procédure, amiable si possible, sinon judiciaire.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Vous pouvez aussi vous trouver face à un problème en matière de <strong>vente</strong>, par exemple
					en cas de vice/non-conformité de la chose faisant l'objet du contrat (un immeuble tel qu'une maison
					ou un appartement, ou un objet tel qu'un véhicule neuf ou d'occasion). Le cabinet vous conseillera
					et vous aidera.
				</p>
				<div className='organigation-text w-[64%] col:float-none  col:w-full mt-[30px]'>
					<h2 className='text-[24px] text-[#282e3f] mb-[8px] block'>Aperçu des Cas Pratiques : </h2>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Bail (résidence principale, commercial, etc…)
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Construction
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Vente (vices cachés, consommation, etc..)
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Recouvrement de créances (factures impayées, etc…)
					</span>
				</div>
			</div>
		</>
	);
};

export default Component;
